<template>
  <div v-if="loading" class="ui active centered inline loader">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>
  <div v-else>
    <div class="ui grid">
      <div class="left aligned five wide column"></div>

      <div class="left aligned eleven wide column">
        <h1 class="ui center aligned icon header" style="color: #092442">
          {{ medicalMachine.name }}
        </h1>
      </div>
    </div>

    <div class="ui divider"></div>
    <div class="ui grid container" style="padding-top: 15px">
      <div class="four wide column">
        <div class="ui grid">
          <div class="row">
            <div class="column">
              <imageComponent :object="medicalMachine"
                              :sendingURL="'medical_machines/' + medicalMachine.id + '/add/image'"
                              :params="{ clinic_id: getFromLocalStorage('clinicId') }">
              </imageComponent>
            </div>
          </div>
        </div>

      </div>
      <div class="twelve wide column" >
        <h4 class="ui dividing header">
          Medical Machine Information
        </h4>
        <abstractTable :data="medicalMachineInfo"
                       :definitionTable="true"
                       :definitionTableWidth="'16%'"
                       :classes="'ui compact definition table'">
        </abstractTable>
      </div>
    </div>
    <medicalMachineDetails
      :medicalMachine="medicalMachine"
      :items="items"
    />
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    imageComponent: require('@/components/abstract_components/Image').default,
    medicalMachineDetails: require('./medical_machine_components/MedicalMachineDetails').default
  },
  data () {
    return {
      medicalMachine: {},
      items: [],
      loading: true,
      packagesKey: 0
    }
  },
  watch: {
    medicalMachine: {
      handler: function () {
        ++this.packagesKey;
      },
      deep: true
    }
  },
  mounted () {
    this.axios.all([this.getMedicalMachine(), this.getItemsMeta()]).then(
      this.axios.spread((medicalMachineResponse, itemsResponse) => {
        this.medicalMachine = medicalMachineResponse.data.medical_machine
        this.medicalMachine.album = { images: [] }
        this.items = itemsResponse.data
        this.medicalMachine.packages = medicalMachineResponse.data.meta.packages
        ++this.packagesKey;
        this.loading = false
      })
    )
  },
  computed: {
    medicalMachineInfo () {
      return {
        name: this.medicalMachine.name,
        origin_country: this.medicalMachine.origin_country,
        location: this.medicalMachine.location,
        bought_at: this.medicalMachine.bought_at
          ? window.moment(this.medicalMachine.bought_at).format('DD/MM/YYYY - hh:mm a') : '-',
        basic_unit_price: this.formatPrice(this.medicalMachine.basic_unit_price),
        unit_measurement: this.medicalMachine.unit_measurement 
          ? this.medicalMachine.unit_measurement.name : '-'
      }
    }
  },
  methods: {
    getMedicalMachine () {
      return this.$http.get(`medical_machines/${this.$route.params.id}`, {
        params: {
          clinic_id: this.getFromLocalStorage('clinicId')
        }
      })
    },
    getItemsMeta () {
      return this.$http.get('items/meta', {
        params: {
          clinic_id: this.getFromLocalStorage('clinicId')
        }
      })
    }
  },
  beforeDestroy () {
    $('#package').remove()
    $('#attach-items').remove()
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/medical_machines/MedicalMachine.vue